<template>
  <div style="display: flex; flex-direction: column; gap: 1em">
    <div style="display: flex; gap: 1em">
      <div class="m-card" style="width: 60%">
        <div style="position: relative">
          <img src="@/assets/images/LTC/map.png" alt="" style="width: 100%" />
          <div v-for="(item, i) in gateway" :key="i">
            <img
              src="@/assets/images/gateway.png"
              :id="item.name"
              alt="gateway"
              :style="{ top: `${item.y}%`, left: `${item.x}%` }"
              style="
                position: absolute;
                width: 4em;
                transform: translate(-50%, -100%);
              "
            />
            <b-tooltip :target="item.name" triggers="hover">
              <div>
                <div>{{ item.name }}</div>
                <div>Status : {{ item.status == 0 ? "OFF" : "ON" }}</div>
                <div>
                  <div style="font-size: 1.5em">
                    {{ item.value }} / {{ item.total }} sensor
                  </div>
                </div>
              </div>
            </b-tooltip>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          gap: 1em;
          width: 40%;
        "
      >
        <card-head :series="gateway_active" :colors="['#3b5aad', '#3b5aad']">
          <template #title> Gateway status </template>
          <template #chart>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="@/assets/images/gateway.png"
                alt="gateway"
                width="100"
                style="pading: 5px"
              />
            </div>
          </template>
          <template #unit> DEVICE </template>
          <template #time>
            {{ gateway_state[0].lastdate }}
          </template>
        </card-head>

        <card-head :series="tag_active" :colors="['#ffd44d', '#fef7af']">
          <template #title> Today total head count </template>
          <template #chart>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="@/assets/images/asset.png"
                alt="gateway"
                width="100"
                style="pading: 5px"
              />
            </div>
          </template>
          <template #unit> PEOPLE </template>
        </card-head>

        <card-head :series="manhour_active" :colors="['#78b63b', '#d1f3ce']">
          <template #title> Today total head manhour </template>
          <template #unit> HOURS </template>
        </card-head>
      </div>
    </div>
    <div>
      <div class="m-card" :style="{ background: gradient }">
        <div class="header">
          <h4 style="font-weight: 700; color: var(--text-color)">
            Workforce Status
          </h4>
        </div>
        <div class="content">
          <vs-table max-items="5" pagination :data="listTagMerge">
            <template slot="header"> </template>
            <template slot="thead">
              <vs-th> </vs-th>
              <vs-th> Worker Name </vs-th>
              <vs-th> Tag MAC Address </vs-th>
              <vs-th> Tag Type </vs-th>
              <vs-th> Today Status </vs-th>
              <vs-th> First Time Found </vs-th>
              <vs-th> Last Time Found </vs-th>
              <vs-th> Last Location Found </vs-th>
              <vs-th> Cumulative Worker Time </vs-th>
              <vs-th> Distance From Gateway </vs-th>
              <vs-th> Tag Battery </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :state="data[indextr].status == 'Present' ? null : 'danger'"
                :key="indextr"
                v-for="(tr, indextr) in data"
                style="text-align: center"
              >
                <vs-td>
                  <vs-button
                    color="success"
                    type="flat"
                    icon="add"
                    @click="goto(data[indextr])"
                    >view</vs-button
                  >
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].mac">
                  {{ data[indextr].mac }}
                </vs-td>

                <vs-td :data="data[indextr].subtype">
                  {{ data[indextr].subtype }}
                </vs-td>
                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>
                <vs-td :data="data[indextr].firstdate">
                  {{ data[indextr].firstdate }}
                </vs-td>
                <vs-td :data="data[indextr].lastdate">
                  {{ data[indextr].lastdate }}
                </vs-td>
                <vs-td :data="data[indextr].last_location">
                  {{ data[indextr].last_location }}
                </vs-td>
                <vs-td :data="data[indextr].manhour">
                  {{ data[indextr].manhour }} hr.
                </vs-td>
                <vs-td :data="data[indextr].distance">
                  {{ data[indextr].distance }}
                  {{ data[indextr].distance == null ? "" : "m." }}
                </vs-td>
                <vs-td :data="data[indextr].battery">
                  {{
                    data[indextr].battery == null
                      ? "null"
                      : data[indextr].battery
                  }}
                  %
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardHead from "./components/CardHead.vue";

export default {
  components: { CardHead },
  computed: {
    gradient() {
      let colors =
        "linear-gradient(180deg," +
        "#8e48c5" +
        " 0px, var(--background-color-sidebar) 45px, var(--background-color-sidebar) 100px)";
      return colors;
    },
  },
  data() {
    return {
      listTagMerge: [],
      listTag: [],
      mac: ["AC233FC0E507"],
      gateway_active: [0, 1],
      tag_active: [0, 1],
      manhour_active: [0, 1],
      gateway_state: [],
      manhouse: [],
      gateway: [
        { name: "Room 1", x: 13, y: 30, status: 0, value: 7, total: 8 },
        // { name: "Meeting Room 2", x: 47, y: 40,status:0, value: 0, total: 4 },
        // { name: "Meeting Room 3", x: 80, y: 40,status:0, value: 0, total: 4 },
        // { name: "Meeting Room 4", x: 13, y: 90,status:0, value: 0, total: 4 },
        // { name: "Meeting Room 5", x: 47, y: 90,status:0, value: 0, total: 4 },
        // { name: "Meeting Room 6", x: 80, y: 90,status:0, value: 0, total: 4 },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/login") {
        vm.$vs.notify({
          time: 4000,
          title: "Welcome",
          text: "ยินดีต้อนรับ เพื่อนพนักงาน เข้าสู่ นิวแคนทีน กรุณาแลกซื้อคูปองอาหาร ด้วยmmoney",
          color: "primary",
          position: "top-center",
        });
      }
    });
  },
  async mounted() {
    console.log(this.prevRoute);
    // this.$vs.notify({
    //   time: 4000,
    //   title: "Welcome",
    //   text: "ยินดีต้อนรับ เพื่อนพนักงาน เข้าสู่ นิวแคนทีน กรุณาแลกซื้อคูปองอาหาร ด้วยmmoney",
    //   color: "primary",
    //   position:'top-center',
    // });
    await this.getDataOne();
    await this.getData();
  },
  methods: {
    goto(item) {
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.subtype);
      this.$session.set("image", item.image);
      this.$session.set("active_status", item.state ? "Absent" : "Present");
      console.log("item", item);
      this.$router.push({
        name: "SensorDashboardIndoor",
        params: {
          sensorname: this.name,
          macname: this.macname,
        },
      });
    },
    async getDataOne() {
      try {
        let indoortag = await this.$API.get("indoortag");
        console.log("indoortag", indoortag.data);
        this.listTag = indoortag.data;
        console.log(this.totalHeadCount);
        let manhouse = await this.$API.get("indoortag/manhour");
        console.log("manhouse", manhouse.data);
        this.manhouse = manhouse;

        let label = [];
        let dataChart = [];
        for (let i = 0; i < manhouse.data.length; i++) {
          const el = manhouse.data[i];
          label.push(el.date);
          dataChart.push(el.manhour);
        }
        this.label = label;
        this.dataChart = dataChart;
        console.log(this.label, this.dataChart);
      } catch (error) {
        console.error(error);
      }
    },
    async getData() {
      try {
        let indoorgateway = await this.$API.get("indoorgateway");
        console.log("indoorgateway", indoorgateway.data);
        this.gateway_state = indoorgateway.data;
        let gateway1 = await this.$API.get("indoorgateway/" + this.mac[0]);
        console.log("gateway1", gateway1.data);

        let G_active = 0;
        for (let i = 0; i < this.gateway_state.length; i++) {
          const el = this.gateway_state[i];
          G_active += el.active;
        }
        this.gateway_active = [G_active, this.gateway_state.length - G_active];

        let arr_gateway1 = [];
        // let arr_gateway2 = [];
        let listTagMerge = [];
        for (let i = 0; i < this.listTag.length; i++) {
          const el = this.listTag[i];
          const found1 = gateway1.data[0].tagfound.find(
            (element) => element.mac == el.mac
          );
          console.log(found1);
          if (found1 != undefined) {
            if (
              this.$moment(found1.timestamp).format("YYYY-MM-DD") ==
              this.$moment().format("YYYY-MM-DD")
            ) {
              arr_gateway1.push(found1);
            }
          }

          //   const found2 = gateway2.data[0].tagfound.find(
          //     (element) => element.mac == el.mac
          //   );
          // console.log(found2);
          //   if (found2 != undefined) {
          //     console.log(this.$moment(found2.timestamp).format("YYYY-MM-DD"));
          //     if (
          //       this.$moment(found2.timestamp).format("YYYY-MM-DD") ==
          //       this.$moment().format("YYYY-MM-DD")
          //     ) {
          //       arr_gateway2.push(found2);
          //     }
          //   }
          let new_tag = { ...found1, ...el };

          new_tag["last_location"] = found1 != undefined ? "Zone 1" : "";

          new_tag["status"] = found1 != undefined ? "Present" : "Absent";

          new_tag["manhour"] =
            new_tag.lastdate == "Invalid date"
              ? 0
              : this.$moment(new_tag.lastdate).diff(
                  this.$moment(new_tag.firstdate),
                  "hours"
                );

          new_tag["distance"] =
            new_tag.rssi == undefined
              ? null
              : Math.pow(10, (-52 - new_tag.rssi) / (10 * 4)).toFixed(2);
          listTagMerge.push(new_tag);
        }
        console.log(listTagMerge);
        this.listTagMerge = listTagMerge;
        this.gateway1 = arr_gateway1;
        // this.gateway2 = arr_gateway2;

        this.activeTag = arr_gateway1;

        this.tag_active = [
          this.activeTag.length,
          this.listTag.length - this.activeTag.length,
        ];
        this.manhour_active = [0, this.listTag.length * 8];

        this.gateway[0].total = this.listTag.length;
        this.gateway[0].value = this.gateway1.length;
        this.gateway[0].status = this.gateway_state[0].active;

        console.log(this.gateway1);
        // get/indoortaglog
      } catch (error) {
        console.error(error);
      }

      //   this.timeout = setTimeout(async () => {
      //     await this.getData();
      //   }, 1000 * 10);
    },
  },
};
</script>

<style>
</style>